import { render, staticRenderFns } from "./registroSintesiPEFC.html?vue&type=template&id=6546f158&external"
import script from "./RegistroSintesiPEFC.vue?vue&type=script&lang=js"
export * from "./RegistroSintesiPEFC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports